import { useEffect } from 'react';

import constants from '@/constants/constants';
import Layout from '@/pcp/components/Layout';
import { useParams } from 'react-router-dom';

export default function HomeRedirect({ to }: { to?: string }) {
  const { token } = useParams<{ token: string }>();

  useEffect(() => {
    const targetURL = `${constants.patientPortalUrl}${to ?? ''}${token ? `/${token}` : ''}${location.search ?? ''}`;
    window.location.replace(targetURL);
  }, [to, token]);

  return <Layout loading showHeader={false} showFooter={false} />;
}
